import { type Components, type Theme } from '@mui/material';

export const MuiListSubheader: Components<Theme>['MuiListSubheader'] = {
  styleOverrides: {
    root: ({ theme: { typography, spacing, palette } }) => ({
      ...typography['natter-text-sm'],
      color: palette.text.primary,
      fontWeight: 600,
      padding: spacing(1, 2),
    }),
  },
};
